"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AcceptedPaymentMethods = /** @class */ (function () {
    function AcceptedPaymentMethods() {
        this.initRendered = false;
    }
    AcceptedPaymentMethods.getPaymentMethodLogoUrl = function (id) {
        return "https://flowcdn.io/util/logos/payment-methods/" + id + "/30/original.png";
    };
    AcceptedPaymentMethods.prototype.render = function (options) {
        if (this.initRendered) {
            return;
        }
        this.forceRender(options);
    };
    AcceptedPaymentMethods.prototype.forceRender = function (_a) {
        var paymentMethods = _a.paymentMethods, mountNodes = _a.mountNodes;
        if (!Array.isArray(mountNodes) || mountNodes.length === 0) {
            return;
        }
        var paymentMethodImgs = paymentMethods.reduce(function (acc, pm) {
            if (!pm.id) {
                return acc;
            }
            var img = document.createElement('img');
            img.src = AcceptedPaymentMethods.getPaymentMethodLogoUrl(pm.id);
            img.alt = pm.id;
            acc.push(img);
            return acc;
        }, []);
        for (var i = 0; i < mountNodes.length; i += 1) {
            // remove div contents before adding PM icons.
            while (mountNodes[i].children.length) {
                mountNodes[i].removeChild(mountNodes[i].children[0]);
            }
            // append PM icon images.
            for (var j = 0; j < paymentMethodImgs.length; j += 1) {
                mountNodes[i].appendChild(paymentMethodImgs[j]);
            }
        }
        this.initRendered = true;
    };
    return AcceptedPaymentMethods;
}());
exports.default = AcceptedPaymentMethods;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/country-picker/~/@flowio/accepted-payment-methods/dist/index.js
// module id = 541
// module chunks = 0 1